import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Holdings from "@/pages/Holdings";
import Entities from "@/pages/Entities";
import Corporate from "@/pages/Corporate";
import Ownership from "@/pages/Ownership";
import Alternatives from "@/pages/Alternatives";
import FixedIncome from "@/pages/FixedIncome";
import Documents from "@/pages/Documents";
import Compliance from "@/pages/Compliance";
import Governance from "@/pages/Governance";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Professionals from "@/pages/Professionals";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#070A0F]">
        <div className="text-[color:var(--mk-muted)] text-sm">Loading vault…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />

            {/* Protected app */}
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/holdings" element={<Protected><Holdings /></Protected>} />
            <Route path="/entities" element={<Protected><Entities /></Protected>} />
            <Route path="/corporate" element={<Protected><Corporate /></Protected>} />
            <Route path="/ownership" element={<Protected><Ownership /></Protected>} />
            <Route path="/alternatives" element={<Protected><Alternatives /></Protected>} />
            <Route path="/fixed-income" element={<Protected><FixedIncome /></Protected>} />
            <Route path="/documents" element={<Protected><Documents /></Protected>} />
            <Route path="/compliance" element={<Protected><Compliance /></Protected>} />
            <Route path="/governance" element={<Protected><Governance /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/professionals" element={<Protected><Professionals /></Protected>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
